import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Resume")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Applications")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Contact")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: _ctx.Paths.HOME
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: _ctx.Paths.RESUME
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: _ctx.Paths.APPLICATIONS
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: _ctx.Paths.CONTACT
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"])
    ], 512), [
      [_vShow, _ctx.show]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}